(function () {
  /* Carousel init — one call per section instance. Instance ids are queued
     by a tiny inline cfg script in sections/explore_shapes_26.liquid (window.__spxCfg_exploreShapes). */
  function spxInitOne(containerId) {
    const container = document.getElementById(containerId);
    if (!container) return;

    const track = container.querySelector('.es-carousel-track');
    const originalItems = Array.from(track.querySelectorAll('.es-carousel-item'));
    const dots = Array.from(container.querySelectorAll('.es-dot'));
    const prevBtn = container.querySelector('.es-prev');
    const nextBtn = container.querySelector('.es-next');
    
    // External Info Elements
    const mobileTitles = Array.from(container.querySelectorAll('.es-mobile-title'));
    const mobileBios = Array.from(container.querySelectorAll('.es-mobile-bio'));

    // Config
    const CENTER_SCALE = parseFloat(container.dataset.centerScale) || 1.5;
    const SIDE_SCALE = parseFloat(container.dataset.sideScale) || 1.0;
    const AUTOPLAY_DURATION = parseFloat(container.dataset.autoplay) || 0;
    
    // SPACING_PERCENT: Distance between items as % of container width.
    // Setting to 50 results in Center (50%), Left (0%), Right (100%).
    // This perfectly aligns to: Center Full, Left Half Visible (if item width ~50%), Right Half Visible.
    const SPACING_PERCENT = 50; 

    // Clone items for infinite loop
    let items = [...originalItems];
    const MIN_CLONES = 10;
    
    if (originalItems.length > 0) {
        while(items.length < MIN_CLONES) {
            originalItems.forEach(item => {
                const clone = item.cloneNode(true);
                clone.classList.add('cloned');
                track.appendChild(clone);
                items.push(clone);
            });
        }
    }

    let currentIndex = 0;
    let targetIndex = 0;
    let isDragging = false;
    let startX = 0;
    let currentX = 0;
    let animationId;
    let autoplayTimer;

    function updateCarousel() {
        const containerWidth = container.offsetWidth;
        
        // Drag Offset
        const dragOffsetPercent = (currentX / containerWidth) * 100;
        const dragIndexOffset = dragOffsetPercent / SPACING_PERCENT;
        
        const effectiveIndex = currentIndex - dragIndexOffset;
        
        items.forEach((item, i) => {
            const totalItems = items.length;
            
            // Circular distance
            let diff = i - effectiveIndex;
            let offset = ((diff % totalItems) + totalItems) % totalItems;
            if (offset > totalItems / 2) offset -= totalItems;
            
            const absOffset = Math.abs(offset);
            
            // Optimization
            if (absOffset > 2.0) {
                item.style.display = 'none';
                return;
            } else {
                item.style.display = 'flex';
            }

            const xPosPercent = offset * SPACING_PERCENT;
            
            item.style.transform = `translate(calc(-50% + ${xPosPercent}vw), -50%)`;
            item.style.zIndex = Math.round(100 - absOffset * 10);
            
            // Scale
            let scale = SIDE_SCALE;
            // Smooth scale curve 
            if (absOffset < 1.0) {
               // Ease scale for center punchiness
               scale = CENTER_SCALE + (SIDE_SCALE - CENTER_SCALE) * absOffset;
            }
            
            const imgWrap = item.querySelector('.es-carousel-image-wrap');
            if(imgWrap) imgWrap.style.transform = `scale(${scale})`;
            
            // Opacity for side items? User didn't strictly ask, but often looks better.
            // Reference images look fully opaque.
            item.style.opacity = 1; 
        });
        
        // Update Info (Title/Bio/Dots)
        // Normalize currentIndex
        let normIndex = Math.round(currentIndex) % originalItems.length;
        if (normIndex < 0) normIndex += originalItems.length;
        
        // Update Dots
        dots.forEach((dot, idx) => {
            if (idx === normIndex) dot.classList.add('active');
            else dot.classList.remove('active');
        });
        
        // Update Titles
        mobileTitles.forEach((el, idx) => {
             // parseInt(dataset.index) matches original index
             if(parseInt(el.dataset.index) === normIndex) el.classList.add('active');
             else el.classList.remove('active');
        });
        
         // Update Bios
        mobileBios.forEach((el, idx) => {
             if(parseInt(el.dataset.index) === normIndex) el.classList.add('active');
             else el.classList.remove('active');
        });
    }

    function snapTo(target) {
        targetIndex = target;
        const start = currentIndex;
        const dist = target - start;
        const duration = 400;
        const startTime = performance.now();
        
        function animate(time) {
            const elapsed = time - startTime;
            const progress = Math.min(elapsed / duration, 1);
            const ease = 1 - Math.pow(1 - progress, 3);
            
            currentIndex = start + (dist * ease);
            updateCarousel();
            
            if (progress < 1) {
                animationId = requestAnimationFrame(animate);
            } else {
                 currentIndex = target;
                 updateCarousel();
            }
        }
        cancelAnimationFrame(animationId);
        animationId = requestAnimationFrame(animate);
    }

    // Events
    container.addEventListener('touchstart', e => {
        isDragging = true;
        startX = e.touches[0].clientX;
        cancelAnimationFrame(animationId);
        stopAutoplay();
    }, {passive: true});
    
    container.addEventListener('touchmove', e => {
        if (!isDragging) return;
        currentX = e.touches[0].clientX - startX;
        requestAnimationFrame(updateCarousel);
    }, {passive: true});
    
    container.addEventListener('touchend', e => {
        isDragging = false;
        startAutoplay();
        const containerWidth = container.offsetWidth;
        const dragOffsetPercent = (currentX / containerWidth) * 100;
        const dragIndexOffset = dragOffsetPercent / SPACING_PERCENT;
        
        currentIndex -= dragIndexOffset;
        currentX = 0;
        snapTo(Math.round(currentIndex));
    });

    prevBtn.addEventListener('click', () => {
        snapTo(Math.round(currentIndex) - 1);
    });
    
    nextBtn.addEventListener('click', () => {
        snapTo(Math.round(currentIndex) + 1);
    });
    
    dots.forEach(dot => {
        dot.addEventListener('click', () => {
            const idx = parseInt(dot.dataset.index);
            const totalOriginal = originalItems.length;
            let currentWrapped = Math.round(currentIndex) % totalOriginal;
            if (currentWrapped < 0) currentWrapped += totalOriginal;
            let diff = idx - currentWrapped;
            if (diff > totalOriginal / 2) diff -= totalOriginal;
            if (diff < -totalOriginal / 2) diff += totalOriginal;
            snapTo(Math.round(currentIndex) + diff);
        });
    });

    updateCarousel();
    
    // Autoplay Logic
    function startAutoplay() {
        if (AUTOPLAY_DURATION <= 0) return;
        stopAutoplay();
        autoplayTimer = setInterval(() => {
            if (!isDragging) {
                snapTo(Math.round(currentIndex) + 1);
            }
        }, AUTOPLAY_DURATION * 1000);
    }

    function stopAutoplay() {
        if (autoplayTimer) clearInterval(autoplayTimer);
    }
    
    // Start initially
    startAutoplay();
    
    // Pause on interactions
    prevBtn.addEventListener('click', () => {
        stopAutoplay(); 
        startAutoplay(); // Restart timer
        snapTo(Math.round(currentIndex) - 1);
    });
    
    nextBtn.addEventListener('click', () => {
        stopAutoplay();
        startAutoplay(); // Restart timer
        snapTo(Math.round(currentIndex) + 1);
    });
    
    dots.forEach(dot => {
        dot.addEventListener('click', () => {
             stopAutoplay();
             startAutoplay();
             
             const idx = parseInt(dot.dataset.index);
             const totalOriginal = originalItems.length;
             let currentWrapped = Math.round(currentIndex) % totalOriginal;
             if (currentWrapped < 0) currentWrapped += totalOriginal;
             let diff = idx - currentWrapped;
             if (diff > totalOriginal / 2) diff -= totalOriginal;
             if (diff < -totalOriginal / 2) diff += totalOriginal;
             snapTo(Math.round(currentIndex) + diff);
        });
    });
  }

  function spxRun() {
    var q = window.__spxCfg_exploreShapes || [];
    while (q.length) spxInitOne(q.shift());
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', spxRun);
  } else {
    spxRun();
  }
})();
